import React from 'react';
import { SpinnerIcon } from '@components-library/Icons/iconsComponents';
import Preloader from '@components-shared/preloader';
import cn from 'classnames';
import styles from './gridNoDataPlaceholder.module.scss';

interface IGridNoDataPlaceholder {
  show: boolean;
  columnsLength: number;
  viewMode?: 'primary' | 'secondary';
}

export const GridSpinner = ({ show, columnsLength, viewMode = 'primary' }: IGridNoDataPlaceholder) => {
  return !show ? null : (
    <tr className={styles.row}>
      <td colSpan={columnsLength} className={styles.noDataCell}>
        <div className={cn(styles.noDataContainer, styles.spinner)}>
          {viewMode === 'primary' ? <SpinnerIcon size={20} /> : <Preloader />}
        </div>
      </td>
    </tr>
  );
};
